import api from "../Service";
import { toastr } from "react-redux-toastr";

const baseController = "api/admin/";

export const getTodaysAuditTrail = async () => {
  if (navigator.onLine === false) {
    toastr.error("No Internet Connection", "Please try again");
  } else {
    try {
      const response = await api.get(`${baseController}dashboard/audit/today`);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          return response.data.data;
        }
      } else {
        toastr.error("An Error occured", "Could not retrieve today's audit trail");
      }
    } catch (ex) {
      toastr.error("An Error occurred", "Please try again");
    }
  }
};

export const getAllAuditTrail = async (body) => {
  if (navigator.onLine === false) {
    toastr.error("No Internet Connection", "Please try again");
  } else {
    try {
      const response = await api.post(`${baseController}dashboard/audit/trails`, body);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          toastr.success("Audit retrieved successfully", "Success");
          return response.data.data.audit_trails;
        }
      } else {
        toastr.error("An Error occured", "Could not retrieve audit trails");
      }
    } catch (ex) {
      toastr.error("An Error occurred", "Please try again");
    }
  }
};

export const getAuditTrailActions = async () => {
  if (navigator.onLine === false) {
    toastr.error("No Internet Connection", "Please try again");
  } else {
    try {
      const response = await api.get(`${baseController}dashboard/audit/all/trail/actions`);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          return response.data.data;
        }
      } else {
        toastr.error("An Error occured", "Could not retrieve today's audit trail");
      }
    } catch (ex) {
      toastr.error("An Error occurred", "Please try again");
    }
  }
};
